export default "__VITE_ASSET__CiE$JZPj__"